/**
 * Created by Languagenut on 29/10/2019.
 */


import React  from 'react';
import {ProgressBar , Badge , Navbar  , Nav , NavDropdown , Button} from 'react-bootstrap'
import AnimatedNumber from 'react-animated-number';
import Table from '../general_table.js';
import Translation from '../../store/internationalization-store.js';
import AssignmentService from '../../services/assignments-service.js';
import AssignmentStore from '../../store/assignment-store.js';
import Constants from '../../constants.js';
import StudentGradeContent from '../popup/grading_popup.js';

export default class Grading extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            gradable:[],
            graded:[],
            tab:'awaiting'
        };
    }

    componentWillMount(){
        AssignmentStore.on(Constants.GET_GRADABLE_QUESTIONS , ()=> {
            var gradable = AssignmentStore.getGradableQuestions();
            var actualGradable = [];
            for (var i = 0;gradable != undefined && i < gradable.length; i++) {
                var currentGradable = gradable[i];
                var madeGradable = [];
                madeGradable.id = i;
                madeGradable.uid = i;
                madeGradable.user_uid = currentGradable.user_uid
                madeGradable.name = currentGradable.nickname;
                madeGradable.section = currentGradable.title
                madeGradable.skill = currentGradable.skill_group
                madeGradable.date = currentGradable.last_updated
                madeGradable.grade = currentGradable.percentage
                if (currentGradable.is_homework != false) {
                    madeGradable.ishomework = "✅";
                } else {
                    madeGradable.ishomework = "";
                }
                madeGradable.rawData = currentGradable
                actualGradable.push(madeGradable);
                if (this.state.tab == "awaiting") {
                    this.setState({tab:"graded"});
                    this.setState({tab:"awaiting"});
                }
            }
            this.setState({loaded:true, gradable:actualGradable})
        })
        AssignmentStore.on(Constants.GET_GRADED_QUESTIONS , ()=> {
            var graded = AssignmentStore.getGradedQuestions();
            var actualGraded = [];
            for (var i = 0; graded != undefined && i < graded.length; i++) {
                var currentGradable = graded[i];
                var madeGradable = [];
                madeGradable.id = i;
                madeGradable.uid = i;
                madeGradable.user_uid = currentGradable.user_uid

                madeGradable.name = currentGradable.nickname;
                madeGradable.section = currentGradable.title
                madeGradable.skill = currentGradable.skill_group
                madeGradable.date = currentGradable.last_updated
                madeGradable.grade = currentGradable.percentage
                if (currentGradable.is_homework != false) {
                    madeGradable.ishomework = "✅";
                } else {
                    madeGradable.ishomework = "";
                }
                madeGradable.rawData = currentGradable
                actualGraded.push(madeGradable);
            }
            this.setState({loaded:true, graded:actualGraded});
            if (this.state.tab == "graded") {
                this.setState({tab:"awaiting"});
                this.setState({tab:"graded"});
            }

        })
    }

    componentDidMount(){
        AssignmentService.getGradableQuestions(this.props.classID);
        AssignmentService.getGradedQuestions(this.props.classID);
    }

    renderOptions(cell, row){
        return <Button onClick={() => this.setState({gradeModalShow:true,uid:row.uid})} size="sm" >{Translation.get(12211 , 'Grade')}</Button>
    }

    renderPercentage(cell, row){

        if(Number(cell) <= 0 || !cell || cell == null)
        {
            return cell
        }

        return <span>{cell}%</span>
    }

    handleSelect(tab){
        this.setState({
            "tab":tab,
        });
    }

    getSkillTranslation(cell){

        var text = [Translation.get('119' , 'notfound') , Translation.get('117' , 'notfound') , Translation.get('118' , 'notfound'), Translation.get('120' , 'notfound')]

        switch(cell){
            case "reading":
                return text[0]
            case "listening":
                return text[1]
            case "speaking":
                return text[2]
            case "writing":
                return text[3]
            default:
                return "-";
        }
    }

    render(){

        let columns = [
            {
                dataField: 'uid',
                text: 'uid',
                searchable: false,
                hidden: true
            },
            {
                dataField: 'name',
                searchable: true,
                text: '',
                hidden: true
            },
            {
                dataField: 'user_uid',
                text: 'user_uid',
                hidden: true
            },
            {
                dataField: 'name',
                searchable: false,
                text: Translation.get(827 , 'Student Name')
            },
            {
                searchable: false,
                dataField: 'section',
                text: Translation.get(12325 , 'Task/Section'),
                formatter:(cell , row)=>{
                    console.log(row)
                    return cell
                }
            },
            {
                searchable: false,
                dataField: 'skill',
                text: Translation.get(12612 , 'Learning Skill'),
                formatter:this.getSkillTranslation
            },
            {
                searchable: false,
                dataField: 'date',
                text: Translation.get(12613 , 'Completed Date'),
                formatter:(cell)=>{
                    return (new Date(cell.replace(" ", "T"))).format('d-m-Y')
                }
            },
            {
                searchable: false,
                dataField: 'grade',
                text: Translation.get(12614, 'Percentage/Grade'),
                hidden:this.state.tab == "awaiting",
                formatter:this.renderPercentage.bind(this)
            },
            {
                searchable: false,
                dataField: 'options',
                text: '',
                align:'right',
                classes: 'note-col',
                headerStyle:()=>{
                    return {
                        width:'90px'
                    }
                },
                formatter:this.renderOptions.bind(this)
            }
        ];


        let sideMenu = <span style={{marginTop:'-4px'}}>
            <Navbar style={{padding:0}}>
                <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                    <Nav.Item>
                        <Nav.Link eventKey="awaiting">{Translation.get(12615 , 'Awaiting Grading')}</Nav.Link>
                    </Nav.Item>
                    &nbsp;  &nbsp;  &nbsp;
                    <Nav.Item>
                        <Nav.Link eventKey="graded">{Translation.get(12616, 'Graded')}</Nav.Link>
                    </Nav.Item>
                </Nav>
            </Navbar>
        </span>;

        if(!this.state.loaded) return <ProgressBar animated now={45} animated />

        let gradeModalClose = () => {
            this.setState({ gradeModalShow: false });
        }

        let onSave = () => {
            AssignmentService.getGradableQuestions(this.props.classID);
            AssignmentService.getGradedQuestions(this.props.classID);
            this.setState({ gradeModalShow: false , loaded:false});
        }

        console.log(this.state.gradeModalShow)
        return <div>
            <StudentGradeContent onSave={onSave} studentName="This is a student name" show={this.state.gradeModalShow} data={this.state.tab == "awaiting" ? this.state.gradable : this.state.graded} uid={this.state.uid} onHide={gradeModalClose} />
            <Table keyField={'uid'} key={'uid'} component={sideMenu} columns={columns}   data={(this.state.tab == "awaiting" ? this.state.gradable : this.state.graded) || []}/>
        </div>


    }

}